import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import React from 'react';
import { DbtAction } from 'libs/end-to-end/src/types/databases/integrations/snowflake-integration';

const dbtActionLabels: Record<DbtAction, string> = {
  '': 'None',
  dbt_export_data_to_s3: 'Export Data to S3',
  dbt_export_panel_data: 'Export Panel Data',
  export_tinuiti_reviews_to_csv: 'Export Tinuiti Reviews to CSV',
  export_workday_candidates: 'Export Workday Candidates',
  export_workday_employees: 'Export Workday Employees',
  export_workday_candidates_needing_resumes_to_csv:
    'Export Workday Candidates Needing Resumes',
  export_workday_employees_needing_resumes_to_csv:
    'Export Workday Employees Needing Resumes',
  export_workday_resumes_needing_parsing_export:
    'Export Workday Resumes Needing Parsing',
  workday_resume_data_export: 'Export Workday Resume Data',
  s3_to_raw_resume_data: 'S3 to Raw Resume Data',
  export_peregrine_outputs: 'Export Peregrine Outputs',
  export_sweetgreen_legion_data: 'Export Sweetgreen Legion Data',
  export_nopd_data: 'Export NOPD Data',
  export_quality_of_hire: 'Export Quality of Hire',
};

export const DataSetIntegrationSnowflakeConfigurationComponent = ({
  dbtAction,
  setDbtAction,
}: {
  dbtAction: DbtAction;
  setDbtAction: (value: DbtAction) => void;
}) => {
  return (
    <Spacing size={'md'} direction={'vertical'}>
      <SelectBoxWithSearch
        type="single"
        list={DbtAction.options.map((action) => ({
          optionLabel: dbtActionLabels[action],
          optionValue: action,
        }))}
        label={'DBT Action'}
        selected={dbtAction}
        setSelected={(value: string) => {
          if (DbtAction.options.includes(value as DbtAction)) {
            setDbtAction(value as DbtAction);
          }
        }}
      />
    </Spacing>
  );
};
